import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "grid grid-cols-8 gap-2 md:gap-6" }
const _hoisted_2 = { class: "col-span-8 md:col-span-3 pt-2.5" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_4 = ["for"]
const _hoisted_5 = ["for"]
const _hoisted_6 = { class: "col-span-8 md:col-span-5" }
const _hoisted_7 = {
  key: 0,
  class: "text-sm md:py-2.5"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 0,
  class: "images-preview mb-4"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex justify-start items-center w-full" }
const _hoisted_12 = {
  for: "dropzone-file",
  class: "flex flex-col justify-start items-center w-full md:w-1/2 h-36 bg-gray-50 rounded-lg border-2 border-gray-300 border-dashed cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
}
const _hoisted_13 = { class: "flex flex-col justify-center items-center pt-5 pb-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 text-sm text-gray-500 dark:text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Click to upload"),
  /*#__PURE__*/_createTextVNode(" or drag and drop ")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, " SVG, PNG, JPG or GIF (MAX. 800x400px) ", -1)
const _hoisted_16 = {
  key: 1,
  class: "bg-indigo-100 text-indigo-500 py-2 px-3 text-sm rounded-md inline-flex items-center mt-2"
}
const _hoisted_17 = ["id", "disabled", "placeholder"]
const _hoisted_18 = {
  type: "button",
  class: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none"
}
const _hoisted_19 = {
  key: 0,
  class: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
  id: "options",
  role: "listbox"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "block truncate text-xs md:text-sm" }
const _hoisted_22 = {
  key: 6,
  class: "relative"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "$")
], -1)
const _hoisted_24 = ["id", "disabled"]
const _hoisted_25 = ["id", "disabled", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EyeOffIcon = _resolveComponent("EyeOffIcon")!
  const _component_EyeIcon = _resolveComponent("EyeIcon")!
  const _component_Wysiwig = _resolveComponent("Wysiwig")!
  const _component_CloudUploadIcon = _resolveComponent("CloudUploadIcon")!
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!
  const _component_SelectorIcon = _resolveComponent("SelectorIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.visibilityControl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (!_ctx.isVisibleModel)
              ? (_openBlock(), _createBlock(_component_EyeOffIcon, {
                  key: 0,
                  class: "w-4 h-4 text-indigo-200 mr-2 cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeVisibility(!_ctx.isVisibleModel)))
                }))
              : (_openBlock(), _createBlock(_component_EyeIcon, {
                  key: 1,
                  class: "w-4 h-4 text-indigo-500 mr-2 cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeVisibility(!_ctx.isVisibleModel)))
                })),
            _createElementVNode("label", {
              for: _ctx.key,
              class: "form-label text-gray-600 text-sm m-0"
            }, _toDisplayString(_ctx.label), 9, _hoisted_4)
          ]))
        : (_openBlock(), _createElementBlock("label", {
            key: 1,
            for: _ctx.key,
            class: "form-label text-gray-600 text-sm m-0"
          }, _toDisplayString(_ctx.label), 9, _hoisted_5))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.type === 'document')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!_ctx.model)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Skipped"))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: _ctx.model,
                  class: "inline-block text-sky font-medium text-sm md:py-2.5",
                  target: "_blank"
                }, "Download", 8, _hoisted_8))
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.type === 'wysiwig')
        ? (_openBlock(), _createBlock(_component_Wysiwig, {
            key: 1,
            modelValue: _ctx.model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model) = $event)),
            placeholder: _ctx.placeholder
          }, null, 8, ["modelValue", "placeholder"]))
        : (_ctx.type === 'gallery-uploader')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (_ctx.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (image) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: image.bytes,
                        class: "image-preview"
                      }, [
                        _createElementVNode("img", {
                          src: image.remoteUrl,
                          alt: "image",
                          class: "md:w-1/2 m-w-full object-cover rounded-lg"
                        }, null, 8, _hoisted_10)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_CloudUploadIcon, { class: "mb-3 w-10 h-10 text-gray-400" }),
                    _hoisted_14,
                    _hoisted_15
                  ]),
                  _createElementVNode("input", {
                    id: "dropzone-file",
                    type: "file",
                    class: "hidden",
                    accept: "image/*",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleImage($event)))
                  }, null, 32)
                ])
              ]),
              (_ctx.file)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createTextVNode(_toDisplayString(_ctx.file.name) + " ", 1),
                    _createVNode(_component_XIcon, {
                      class: "w-3 h-4 ml-2 cursor-pointer",
                      onClick: _ctx.removeFile
                    }, null, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_ctx.appearance === 'address' || _ctx.label.includes('address'))
            ? (_openBlock(), _createBlock(_component_GMapAutocomplete, {
                key: 3,
                placeholder: "Start typing...",
                options: {
            componentRestrictions: { country: 'us' }
          },
                value: _ctx.model,
                class: "border rounded-md h-10 max-w-xs w-full text-sm px-3",
                onPlace_changed: _ctx.saveAddress
              }, null, 8, ["value", "onPlace_changed"]))
            : (_ctx.type === 'textarea')
              ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                  key: 4,
                  class: _normalizeClass(["border rounded-md max-w-xs w-full text-sm p-2 px-3", { 'border-red-600': !_ctx.isValid }]),
                  id: _ctx.key,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model) = $event)),
                  disabled: _ctx.disabled,
                  rows: "3",
                  placeholder: _ctx.placeholder
                }, null, 10, _hoisted_17)), [
                  [_vModelText, _ctx.model]
                ])
              : (_ctx.type === 'selector' || _ctx.type === 'boolean')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 5,
                    ref: "target",
                    class: "relative w-full max-w-xs",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["w-full rounded-md border bg-white py-2 pl-3 pr-12 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 text-xs text-sm", { 'border-red-600': !_ctx.isValid }]),
                      role: "combobox",
                      "aria-controls": "options",
                      "aria-expanded": "false",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model) = $event)),
                      readonly: ""
                    }, null, 2), [
                      [_vModelText, _ctx.model]
                    ]),
                    _createElementVNode("button", _hoisted_18, [
                      _createVNode(_component_SelectorIcon, { class: "w-4 h-4" })
                    ]),
                    (_ctx.isOpened)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (value, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: index,
                              class: "relative cursor-pointer select-none py-2 pl-3 pr-9 text-gray-900 hover:bg-sky hover:text-white",
                              role: "option",
                              tabindex: "-1",
                              onClick: ($event: any) => (_ctx.updateValue(value))
                            }, [
                              _createElementVNode("span", _hoisted_21, _toDisplayString(value), 1)
                            ], 8, _hoisted_20))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 512))
                : (_ctx.type === 'numeric' && _ctx.appearance === 'currency')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _hoisted_23,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["border rounded-md h-10 max-w-xs w-full text-sm px-3 pl-6", { 'border-red-600': !_ctx.isValid }]),
                        id: _ctx.key,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model) = $event)),
                        disabled: _ctx.disabled
                      }, null, 10, _hoisted_24), [
                        [_vModelText, _ctx.model]
                      ])
                    ]))
                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 7,
                      type: "text",
                      class: _normalizeClass(["border rounded-md h-10 max-w-xs w-full text-sm px-3", { 'border-red-600': !_ctx.isValid }]),
                      id: _ctx.key,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model) = $event)),
                      disabled: _ctx.disabled,
                      placeholder: _ctx.placeholder
                    }, null, 10, _hoisted_25)), [
                      [_vModelText, _ctx.model]
                    ])
    ])
  ]))
}